import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';
import { ConverterAnalyticsEventType } from '@quicktools/shared-components/services/converter-analytics';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

const page_name = 'main';

const TOOL_MAP: { [key: string]: string } = {
  em: 'emojis',
  sy: 'symbols',
  fg: 'font_generator',
};

class Analytics extends AnalyticsGTM {
  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
    });
  }

  pageOpen() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }

  textBoxClick() {
    this.event('text_box_click');
  }

  textBoxType() {
    this.event('text_box_type');
  }

  emojiCopy(category_name: string, emoji_name: string) {
    this.sendGaEvent('emoji_copy', {
      page_name,
      category_name,
      emoji_name,
    });
  }

  emojiPageOpen(pageName: string, tool: string) {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: pageName,
      tool_name: tool,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
  }

  emojiArrayCopy() {
    this.event('emoji_array_copy');
  }

  emojiArrayClear() {
    this.event('emoji_array_clear');
  }

  deviceTypeSwitch(category_name: string, value: boolean) {
    this.sendGaEvent('device_type_switch', {
      page_name,
      category_name,
      value: value ? 'on' : 'off',
    });
  }

  filterOpen() {
    this.event('filter_open');
  }

  filterApply() {
    this.event('filter_apply');
  }

  filterSwitch(filter_name: string) {
    this.sendGaEvent('filter_switch', {
      page_name,
      filter_name,
    });
  }

  toggleClick(name: string) {
    this.sendGaEvent('toggle_click', {
      page_name,
      destination: TOOL_MAP[name],
    });
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
